import { o_util } from "@gr-common/head/namespaces";
import { assignNamespace } from "@gr-common/head/namespace-utils";
import { deprecated } from "@gr-common/head/logger";
import { isEmptyObject, isPlainObject } from "./object";
import { serialize, serializeForm, deserialize, coerce } from "./serialize";
import {
  runWithAnimationFrame,
  runWithRenderSlice,
  runWithMacrotask,
  runWithMicrotask,
} from "./promise";

export { isEmptyObject, isPlainObject } from "./object";

export { serialize, serializeForm, deserialize, coerce };
export type { Serializable } from "./serialize";

export { runWithAnimationFrame, runWithRenderSlice, runWithMacrotask, runWithMicrotask };

const message = "Use navigation module instead.";
const mod = "core";

assignNamespace(o_util, mod, {
  isEmptyObject,
  isPlainObject,

  runWithMicrotask,
  runWithMacrotask,
  runWithRenderSlice,
  runWithAnimationFrame,

  /*            */
  coerce: deprecated(coerce, mod, "coerce", message),
  deserialize: deprecated(deserialize, mod, "deserialize", message),
  serialize: deprecated(serialize, mod, "serialize", message),
  serializeForm: deprecated(serializeForm, mod, "serializeForm", message),
});
